export default "__VITE_ASSET__DDzmlnAq__"